import { render, staticRenderFns } from "./ImagesUpload.vue?vue&type=template&id=4b08a989&scoped=true"
import script from "./ImagesUpload.vue?vue&type=script&lang=ts"
export * from "./ImagesUpload.vue?vue&type=script&lang=ts"
import style0 from "./ImagesUpload.vue?vue&type=style&index=0&id=4b08a989&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b08a989",
  null
  
)

export default component.exports